import { useAppSelector } from '@/Hook/hooks';
import { ArrayKeyValueObject, KeyValueObject } from '@/UI/Interfaces/IBaseUI';
import BaseMethods from 'AlignBaseUI/BaseMethods';
import { ControlTranslation } from 'AlignComponents';
import React, { useEffect, useRef, useState } from 'react';
import { Card, Col, Nav, Row, Tabs, Tab } from 'react-bootstrap';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { HiUserGroup } from 'react-icons/hi';
// @ts-ignore
import OrgChart from 'react-orgchart';
import 'react-orgchart/index.css';
import { useHistory } from 'react-router';

const NodeComponent = ({ node }: any) => (
  <div className="node">
    <div className="node-item">
      <img src={BaseMethods.getUserPhoto(node.employeeimage)} alt="" />
      <div className="node-text">
        <h6>{node.employeestxt}</h6>
        <span>{node.positionstxt}</span>
      </div>
    </div>
  </div>
);

const MyTeam = () => {
  const history = useHistory();
  const { myTeam, myTeamAtt } = useAppSelector(x => ({
    myTeam: x.Home.SelfService.myTeam,
    myTeamAtt: x.Home.SelfService.myTeamAtt
  }));
  const [structuredData, setStructuredData] = useState<any>(null);

  const transformToHierarchy = (data: ArrayKeyValueObject) => {
    const employeeMap = new Map();
    data.forEach((employee: KeyValueObject) => {
      employeeMap.set(employee.employeeno, { ...employee, children: [] });
    });

    let root = null;
    data.forEach((employee: KeyValueObject) => {
      const parent = employeeMap.get(employee.reportingto);
      if (!employee.reportingto || employee.employeeno === employee.reportingto) {
        root = employeeMap.get(employee.employeeno);
      } else if (parent) {
        parent.children.push(employeeMap.get(employee.employeeno));
      }
    });

    return root;
  };

  useEffect(() => {
    if (myTeam.length >= 1) setStructuredData(transformToHierarchy(myTeam));
  }, [myTeam]);

  return (
    <Card className="my-team">
      <Card.Header>
        <Card.Title>
          <HiUserGroup size={18} className="icon" />
          <ControlTranslation system={true} controlId="lblmyteam" />
        </Card.Title>
        <Nav.Link className="view-ornanogram ms-auto" onClick={() => history.push('/Ornanogram')}>
          <ControlTranslation system={true} controlId="lblviewornanogram" />
        </Nav.Link>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md="8">
            <div className="my-team-chart">
              {myTeam.length >= 1 && structuredData && (
                <OrgChart
                  className="org-chart"
                  tree={structuredData}
                  NodeComponent={NodeComponent}
                />
              )}
            </div>
          </Col>
          <Col md="4">
            <div className="my-team-today-attendance">

              <Tabs
                defaultActiveKey="present"
              >
                <Tab eventKey="present" title="Present">
                  <div className="my-team-items">
                    {
                      myTeamAtt.filter(x => x.attendancestatus == "Present").map((x, i) => (
                        <div className="my-team-today-item" key={i}>
                          <img src={BaseMethods.getUserPhoto(x.employeeimage)} alt="" />
                          <h6>{x.employeestxt}</h6>
                          <span>{x.positionstxt}</span>
                        </div>
                      ))
                    }
                  </div>
                </Tab>
                <Tab eventKey="absent" title="Absent">
                  <div className="my-team-items">
                    {
                      myTeamAtt.filter(x => x.attendancestatus == "Absent").map((x, i) => (
                        <div className="my-team-today-item" key={i}>
                          <img src={BaseMethods.getUserPhoto(x.employeeimage)} alt="" />
                          <h6>{x.employeestxt}</h6>
                          <span>{x.positionstxt}</span>
                        </div>
                      ))
                    }
                  </div>
                </Tab>
                <Tab eventKey="leave" title="Leave">
                  <div className="my-team-items">
                    {
                      myTeamAtt.filter(x => x.attendancestatus == "Leave").map((x, i) => (
                        <div className="my-team-today-item" key={i}>
                          <img src={BaseMethods.getUserPhoto(x.employeeimage)} alt="" />
                          <h6>{x.employeestxt}</h6>
                          <span>{x.positionstxt}</span>
                        </div>
                      ))
                    }
                  </div>
                </Tab>
                <Tab eventKey="halfDay" title="Half Day">
                  <div className="my-team-items">
                    {
                      myTeamAtt.filter(x => x.attendancestatus == "Half Day").map((x, i) => (
                        <div className="my-team-today-item" key={i}>
                          <img src={BaseMethods.getUserPhoto(x.employeeimage)} alt="" />
                          <h6>{x.employeestxt}</h6>
                          <span>{x.positionstxt}</span>
                        </div>
                      ))
                    }
                  </div>
                </Tab>
                <Tab eventKey="late" title="Late">
                  <div className="my-team-items">
                    {
                      myTeamAtt.filter(x => x.attendancestatus == "Late").map((x, i) => (
                        <div className="my-team-today-item" key={i}>
                          <img src={BaseMethods.getUserPhoto(x.employeeimage)} alt="" />
                          <h6>{x.employeestxt}</h6>
                          <span>{x.positionstxt}</span>
                        </div>
                      ))
                    }
                  </div>
                </Tab>
              </Tabs>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default MyTeam;
